// Stub for isProductConfigurable
export function isProductConfigurable(product) {
    return product?.__typename === 'ConfigurableProduct' || 
           product?.type_id === 'configurable';
}
